(function(){
  var root = document.querySelector('.vg');
  if (!root) return;

  // Only enable the reveal-on-scroll effect if JS actually runs —
  // otherwise (JS disabled) everything stays visible by default,
  // since .vg-reveal is only hidden once .vg-js is present.
  root.classList.add('vg-js');

  var targets = root.querySelectorAll('.vg-reveal');
  if (!('IntersectionObserver' in window) || !targets.length) {
    targets.forEach(function(el){ el.classList.add('vg-in'); });
    return;
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('vg-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  targets.forEach(function(el){ io.observe(el); });
})();